import React from 'react';
import { Card } from '../ui/card';
import { totalCapacity } from '../../lib/arenaUtils';

export default function StatsPanel({ sectors, removedSeats, flexZones }) {
  const stats = totalCapacity(sectors, removedSeats, flexZones);

  return (
    <Card className="p-4 bg-stone-900 text-stone-50 border-stone-800" data-testid="stats-panel">
      <h3 className="text-[10px] tracking-[0.2em] uppercase text-stone-400 mb-3">Kapacitás</h3>

      <div className="space-y-3">
        <StatRow label="Összes szék" value={stats.totalSeats} />
        <StatRow label="Kivett székek" value={stats.removedSeats} accent="rose" />
        <StatRow label="Elérhető székek" value={stats.availableSeats} accent="sky" />
        <StatRow label="Flex zóna fő" value={stats.flexPeople} accent="emerald" />

        <div className="pt-3 mt-3 border-t border-stone-700">
          <div className="text-[10px] tracking-[0.2em] uppercase text-stone-400 mb-1">Végső kapacitás</div>
          <div className="text-4xl font-black tracking-tight text-amber-400" data-testid="grand-total">
            {stats.grandTotal.toLocaleString('hu-HU')}
          </div>
          <div className="text-xs text-stone-500 mt-0.5">fő</div>
        </div>
      </div>
    </Card>
  );
}

const StatRow = ({ label, value, accent }) => {
  const colors = {
    rose: 'text-rose-400',
    sky: 'text-sky-400',
    emerald: 'text-emerald-400',
  };
  return (
    <div className="flex items-center justify-between" data-testid={`stat-${label}`}>
      <span className="text-xs text-stone-400">{label}</span>
      <span className={`text-base font-bold tabular-nums ${colors[accent] || 'text-stone-100'}`}>
        {value.toLocaleString('hu-HU')}
      </span>
    </div>
  );
};
